import React from 'react'
import {Link} from 'react-router-dom'




const DevotionalHomeWeeklyCard = (props) => {
  
      const {data}=props;



  return (
    <div className='devotional-home-weekly-card'>
        <Link to={data.link}>
        <img src={data.url} alt="weekly-card-img" />
        </Link>
    </div>
  )
}

export default DevotionalHomeWeeklyCard;
